import React, { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useCurrentUser } from '../../../../utils/hooks/useCurrentUser';
import LoggedInMenu from './_partials/LoggedInMenu';
import LoggedOutMenu from './_partials/LoggedOutMenu';
const UserMenuMobile = (props)=>{
    const { isLoggedIn } = useContext(SessionContext);
    const currentUser = useCurrentUser();
    return isLoggedIn && currentUser ? /*#__PURE__*/ React.createElement(LoggedInMenu, props) : /*#__PURE__*/ React.createElement(LoggedOutMenu, props);
};
UserMenuMobile.displayName = 'UserMenuMobile';
export default UserMenuMobile;

//# sourceMappingURL=UserMenuMobile.js.map